module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


// WEBPACK FOOTER //
// ./~/babel-runtime/core-js/array/from.js